import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noWhitespaceValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value: string = control.value ?? '';
  return value.trim().length === 0 && value.length > 0
    ? { noWhitespace: true }
    : null;
}
